import { memo } from 'react';
import Div from '../Div';
import Paragraph from '../Paragraph';
import Button from '../Button';
import ShowHideText from './ShowHideText';
import Map from '@/components/Map';
import date from '@/utils/date';

const Coupon = (props: any) => {
  const { onApply, cartId } = props;
  const { coupon, description, terms, expiry } = props.value;
  const daysDifference = date.getDaysDifferenceforCoupon(expiry);

  const apply = async () => {
    onApply(props.value);
  };

  return (
    <Div className="bg-cs-primary rounded-cs overflow-hidden relative">
      <Div className="flex flex-col gap-s4 p-s5 border-l border-t border-r border-cm-subtle rounded-t-cs">
        <Div className="flex flex-row gap-s3">
          <Paragraph className="flex-1 text-h-4 md:text-hd-4">{coupon}</Paragraph>
          <Paragraph className="text-body-base text-cu-positive">
            {expiry && daysDifference}
          </Paragraph>
        </Div>
        <Paragraph className="text-body-lg line-clamp-2">{description}</Paragraph>
        <ShowHideText>
          <Map
            list={terms}
            render={(item, index) => {
              return (
                <Paragraph key={index} className="text-body-sm">
                  {item}
                </Paragraph>
              );
            }}
          />
        </ShowHideText>
      </Div>

      <Div className="border-b border-dashed border-cm-subtle" forceRender={true} />

      <Button
        className="text-button-normal text-cu-positive !items-center w-full px-s5 py-s4 bg-green-100 border-l border-b border-r border-cm-subtle rounded-b-cs"
        theme="none"
        onClick={apply}
      >
        TAP TO APPLY
      </Button>

      <Div
        className="absolute -left-2 bottom-10 h-4 w-4 bg-cs-secondary rounded-full rotate-90 border border-cm-subtle"
        forceRender={true}
      />

      <Div
        className="absolute -right-2 bottom-10 h-4 w-4 bg-cs-secondary rounded-full -rotate-90 border border-cm-subtle"
        forceRender={true}
      />
    </Div>
  );
};

export default memo(Coupon);
